// extracted by mini-css-extract-plugin
export default {"command-box":"command-box__X2C1t","commandBox":"command-box__X2C1t"};